import React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";

import { ErrorBoundary } from "../atoms/ErrorBoundary";
import { AnnouncementGames } from "../constants/AnnouncementGames";
import { Game as GameModel } from "../models/Game";
import { User } from "../models/User";
import { UrlService } from "../services/UrlService";
import { set404Status, setTheaterMode } from "../store/reducers";
import { AnnouncementTemplate } from "../templates/Annoucment/Annoucment";
import { GameTemplate } from "../templates/Game/Game";
import { GameState } from "../models/Enums";
import { P404Template } from "../templates/p404/p404";

type GamePageProps = {
  game: GameModel;
  gameAnnounce: any;
  games: any[];
  user: User;
  match: any;
  dispatch?: any;
  url: string;
  customVersion?: string;
  customApi?: string;
  gameState: GameState;
};

interface RootState {
  user: User;
  games: any[];
  gameState: GameState;
  isTheaterMode: boolean;
}

class Page extends React.PureComponent<GamePageProps> {
  set404Status = () => {
    this.props.dispatch(set404Status(true));
  };

  setIsTheaterMode = () => {
    this.props.dispatch(setTheaterMode(false));
  };

  componentDidMount() {
    this.setIsTheaterMode();
  }

  render() {
    const { customVersion, gameAnnounce, game, games, customApi } = this.props;
    if (gameAnnounce) {
      return (
        <ErrorBoundary>
          <AnnouncementTemplate
            games={this.props.games}
            gameData={gameAnnounce}
          />
        </ErrorBoundary>
      );
    }

    if (!game) {
      this.set404Status();
      return <P404Template games={games} />;
    }

    if (customApi) {
      game.assetOriginUrl = customApi;
    } else if (customVersion) {
      game.version = customVersion;
      game.updateAssetsOriginURL();
    }

    return (
      <ErrorBoundary>
        <GameTemplate
          games={games}
          game={game}
          user={this.props.user}
          url={this.props.url}
          gameState={this.props.gameState}
        />
      </ErrorBoundary>
    );
  }
}

export const Game = connect(
  (state: RootState, props: RouteComponentProps<any>) => ({
    game: selectGame(state, props.match.params.game),
    gameAnnounce: AnnouncementGames[props.match.params.game],
    games: state.games,
    user: state.user,
    url: UrlService.buildAbsoluteUrl(props),
    customVersion: UrlService.getCustomVersionParam(props),
    customApi: UrlService.getGameCustomApi(props),
    gameState: state.gameState,
    isTheaterMode: state.isTheaterMode,
  })
)(Page);

function selectGame(state, gameParam): GameModel {
  const gameCurrent = state.games.find(
    (game) => game && game.seo_URLAlias === gameParam
  );
  if (gameCurrent) {
    const gameModel = new GameModel(gameCurrent);
    return gameModel;
  }
  return null;
}
